import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ProjectModel } from '../../../model/project.model';
import { LocaleUtils } from '@shared/util/locale-utils';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';

@Component({
  standalone: false,
  selector: 'app-project-loading-corrupt-articles',
  templateUrl: './project-loading-corrupt-articles.component.html',
  styleUrls: ['./project-loading-corrupt-articles.component.scss']
})
export class ProjectLoadingCorruptArticlesComponent implements OnInit {
  @Output() public finish = new EventEmitter<CorruptArticleAction>();
  public corruptArticles: { articleNo: string, description: string }[] = [];

  constructor(
    private projectModel: ProjectModel,
    private localeResourceManager: LocaleResourceManager,
  ) {}

  public ngOnInit() {
    this.corruptArticles = this.projectModel.corruptArticles.map((articleContainer) => {
      return {
        articleNo: articleContainer.article.articleNo,
        description: LocaleUtils.getValueByLocaleChain(articleContainer.article.displayName, this.localeResourceManager.getLocaleChain()),
      };
    });
  }

  remove() {
    this.finish.emit(CorruptArticleAction.DELETE);
  }

  cancel() {
    this.finish.emit(CorruptArticleAction.IGNORE);
  }
}

export enum CorruptArticleAction {
  DELETE,
  IGNORE
}
